import { chartGridPositions } from '../../../../../../shared/constants/chart';

interface ChartYAxisGridProps {
  bottomOffset: string;
}
function ChartYAxisGrid({ bottomOffset }: ChartYAxisGridProps) {
  return (
    <div>
      {chartGridPositions.map((pos) => {
        const style = pos === 100 ? { right: 0 } : { left: `${pos}%` };
        return (
          <div
            key={pos}
            className={`bg-black-200 absolute top-8 w-[1px] ${bottomOffset}`}
            style={style}
          />
        );
      })}
    </div>
  );
}

export default ChartYAxisGrid;
